import { render } from "./createmail.vue?vue&type=template&id=16f30856"
import script from "./createmail.vue?vue&type=script&lang=js"
export * from "./createmail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__